module.exports = __webpack_public_path__ + "static/media/login.31808a00.jpg";